import { legacy_createStore as createStore, applyMiddleware, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { shared }from './shared/reducer';

const rootReducer = combineReducers({
    shared
});
export const store = createStore(
    rootReducer,
    applyMiddleware(
        thunkMiddleware,
    )
);